export const ORDER_BY_OPTIONS = {
  column: 'time', // TODO: check for correct column
  direction: 'desc'
};

export const TABLE_KEY = 'SENDOUT_INTERVIEWS_TABLE';

export const SENDOUT_INTERVIEWS_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'interviewType',
    label: 'Interview Type',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'interviewDate',
    label: 'Interview Date',
    options: {
      filter: true,
      display: true
    }
  },
  {
    name: 'otherInterviewer',
    label: 'Other Interviewer',
    options: {
      filter: false,
      display: true
    }
  }
];
